import logo72x72 from "./logo76x76.png";
import logo96x96 from "./logo96x96.jpg";
import logo192x192_blue from "./logo192x192.png";
import logo192x192 from "./logo192x192_white.png";
import logo138x75black from "./logo138x75black.png";
import logo138x75white from "./logo138x75white.png";
import logo192x192_white from "./logo192x192_white.png";
import logo165x90white from "./logo165x90white.png"
import logo1024x1024 from "./logo1024x1024.png";
import intro from "./splash.png";
import bg from "./bg.jpg";
import header from "./Header.png";

export default {
    logo72x72,
    logo96x96,
    logo192x192,
    logo138x75black,
    logo138x75white,
    logo1024x1024,
    logo165x90white,
    intro,
    bg,
    logo192x192_blue,
    header,
    logo192x192_white
}